// extracted by mini-css-extract-plugin
export default {"premiumTag":"PremiumTag_premiumTag__07gA0","premiumTag__text":"PremiumTag_premiumTag__text__4bsmj"};